import API_URL from "@/constant/api.config"
import axios from "axios"
import axiosInstance from '@/axiosHttp';

export const postInquiry = async (reqData) => {
    const response = await axios
        .post(API_URL + "/inquiry-us", reqData, {
            headers: {
                Accept: "application/json",
            },
            timeout: 10000,
        });
    return response.data ? response.data : null;
}

export const fetchFilteredInquiries = async (filters) => {
    const response = await axios.post(API_URL + "/view-all-inquiry", filters, {
        headers: { Accept: "application/json" },
        timeout: 10000,
    });
    return response.data ? response.data : null;
};

// used for BookADemo
export const addInquiry = async (reqData) => {
    const response = await axios.post(API_URL + "/inquiry/add", reqData, {
        headers: { Accept: "application/json" },
        timeout: 10000,
    });
    return response.data ? response.data : null;
};

export const postSupplierInq = async (reqData) => {
    const response = await axiosInstance.post(API_URL + "/supplier-inquiry/add", reqData, {
        headers: { Accept: "application/json" },
        timeout: 10000,
    });
    return response.data ? response.data : null;
}

export const postSupplierInqWithoutLogin = async (reqData) => {
    console.log("postSupplierInqWithoutLogin is called..............");
    const response = await axios.post(API_URL + "/create-supplier-inquiry", reqData, {
        headers: { Accept: "application/json" },
        timeout: 10000,
    });
    return response.data ? response.data : null;
}